// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8888854c","703":"824d0fb0","787":"7acd20c3"}[chunkId] + ".chunk.js";
};